<template>
    <div class="pdfbox flex-column-center">
        <div class="title">操作手册</div>
        <div class="pdfbox_content" id="pdfbox_content">
            <pdf class="pdfStyle" ref="pdf" :src="url" :page="pageNum" :rotate="pageRotate" @progress="loadedRatio = $event"
                @page-loaded="pageLoaded($event)" @num-pages="pageTotalNum = $event" @error="pdfError($event)"
                @link-clicked="page = $event" :scale="pdfscale">
            </pdf>
        </div>
        <div class="tools flex-align-center">
            <el-button size="mini" type="primary" @click.stop="prePage">上一页</el-button>
            <el-button size="mini" type="primary" @click.stop="nextPage">下一页</el-button>
            <span class="page">{{ pageNum }}/{{ pageTotalNum }} </span>
        </div>

    </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
    //import引入组件才能使用
    components: {
        pdf
    },
    props: {},
    data() {
        return {
            // url: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf",
            url: '',
            pageNum: 1,
            pageTotalNum: 1,
            pageRotate: 0,
            // 加载进度
            loadedRatio: 0,
            curPageNum: 0,
            pdfscale: 10,
            pdflist: {
                '北京': {
                    '1': '/beijingpdf1.pdf',
                    '2': '/beijingpdf2.pdf',
                    '3': '/beijingpdf3.pdf',
                },
                '内蒙古': {
                    '1': '/nmgpdf1.pdf',
                    '2': '/nmgpdf2.pdf',
                    '3': '/nmgpdf3.pdf',
                }
            }
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        getNumPages() {
            let loadingTask = pdf.createLoadingTask(this.pdflist[this.$route.query.fileName][this.$route.query.fileIndex]);
            loadingTask.promise
                .then((pdf) => {
                    this.url = loadingTask;
                })
                .catch((err) => {
                    console.error("pdf 加载失败", err);
                });
        },
        // 上一页函数，
        prePage() {
            var page = this.pageNum
            page = page > 1 ? page - 1 : this.pageTotalNum
            this.pageNum = page;
            let dom = document.getElementById('pdfbox_content');
            dom.scrollTop = 0;
        },
        // 下一页函数
        nextPage() {
            var page = this.pageNum
            page = page < this.pageTotalNum ? page + 1 : 1
            this.pageNum = page;
            let dom = document.getElementById('pdfbox_content');
            dom.scrollTop = 0;
        },
        // 页面加载回调函数，其中e为当前页数
        pageLoaded(e) {
            this.curPageNum = e;
        },
        // 其他的一些回调函数。
        pdfError(error) {
            console.error(error)
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getNumPages();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.state.user.token == null ? next('/home/page') : next();
        })
    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style  lang="less" scoped>
@import "./less/help_pdf";
</style>